import React from 'react';

import './Light.scss';

class Light extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      status: this.props.state
    }
  }

  positionDict = {
    'Pizarra': 'b1',
    'PAPI': 'p1',
    'F1': 'f1',
    'F2': 'f2',
    'F3': 'f3',
    'Logo': 'l1'
  }

  render() {
    return (
      <div className={`Light position-${this.positionDict[this.props.name]} state-${this.props.state}`}
           data-position={this.positionDict[this.props.name]}>
        {this.props.name}
      </div>
    );
  }
}


export default Light;
